export default __webpack_public_path__ + "static/top_logos-d20d62918b78fb2c3b3aa26259ba582f.png";